import { useState } from 'react'

export default function EditableField({ label, value, lowConfidence = false, onCommit }) {
  const [editing, setEditing] = useState(false)
  const [draft, setDraft] = useState(value || '')

  const commit = () => {
    setEditing(false)
    if (draft !== value) onCommit?.(draft)
  }
  const cancel = () => {
    setEditing(false)
    setDraft(value || '')
  }

  return (
    <div className="flex flex-col gap-1 border-b border-line/60 py-2.5 last:border-0 sm:grid sm:grid-cols-[160px_1fr] sm:items-center sm:gap-3.5">
      <div className="text-[12px] text-muted">{label}</div>
      <div className="flex items-center gap-2 text-[14px] sm:text-[13.5px]">
        {editing ? (
          <input
            autoFocus
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            onBlur={commit}
            onKeyDown={(e) => e.key === 'Enter' ? commit() : e.key === 'Escape' ? cancel() : null}
            className="flex-1 rounded-md border border-terra-500 bg-white px-2 py-1 text-[13.5px] focus:outline-none"
          />
        ) : (
          <span
            className={`flex-1 cursor-text rounded-md px-2 py-1 hover:bg-bg ${value ? '' : 'text-muted'}`}
            onClick={() => setEditing(true)}
          >{value || 'Non précisé'}</span>
        )}
        {lowConfidence && !editing && (
          <span className="rounded-full bg-fiscal-bg px-1.5 py-[2px] text-[10.5px] font-medium text-fiscal-fg">à confirmer</span>
        )}
      </div>
    </div>
  )
}
